module.exports = __webpack_public_path__ + "static/media/arrowDownAccordionIcon.f3dc8e19.svg";